import * as couponRe from '../services/couponRe';

export default {
  namespace: 'couponRe',
  state: {},
  effects: {
    *getQueryStaffTransLogPage({ payload: { values } }, { call, put }) {
      const response = yield call(couponRe.getQueryStaffTransLogPage, values);
      yield put({
        type: 'save',
        payload: {
          couponReList: response.data.data,
          total: response.data.total,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
